module.exports = __webpack_public_path__ + "img/non-monetary_2x.4b11965.png";


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/raf/non-monetary_2x.png
// module id = 691
// module chunks = 0